// Types.
import { states, state } from '../Types/State';

// Classes.
import Handler from './Handler';
import type event from "../Types/Event";
import Listener from "./Listener";

// Interfaces.
import { ThresholdOptions } from '../Interfaces/Options';

// Methods.
import { isSelector, toPx, toNode } from '../Helpers/Helpers';

/**
 * Scrolly.Threshold
 *
 * @author: FelixKiesewetter <info@felixkiesewetter.de>
 * @lastModified: 2026-06-16 Improved.
 * @package fk_js/scrolly
 * @version: 1.1.0
 */
class Threshold extends Handler<ThresholdOptions>
{

    private state :state = states.BEFORE;

    /**
     * Constructor.
     */
    constructor(options: ThresholdOptions)
    {
        super(options);
        if (isSelector(this.options.threshold) && 'intersectionObserver' === this.options.method) {
            this.observer.observe(toNode(this.options.threshold) as HTMLElement, (entry :IntersectionObserverEntry) :void => {
                // TODO: do something with it ... console.log('TODO', IntersectionObserverEntry);
            });
        }
    }

    /**
     * Define default options.
     */
    public defaults(): ThresholdOptions
    {
        return {
            method: 'requestAnimationFrames',
            onChange: (state: state) :void => {},
            threshold: '100px',
            // TODO: right now threshold is passed as soon as the top of the element enters bottom of viewport => option to set target (say, MIDDLE of the window)
        };
    }

    /**
     * This handler listens to the scroll event.
     */
    public events(): event[]
    {
        return [ 'init', 'scroll', 'resize' ];
    }

    /**
     * Check if any animation frames should be queued or not and return them in an array.
     */
    public requestAnimationFrames(event :Event, handler :Listener) :Function[]
    {
        const animationFrames :Function[] = [];
        if (
            this.options.method !== 'requestAnimationFrames' ||
            (
                'scroll' !== event.type &&
                'init' !== event.type
            )
        ) {
            return animationFrames;
        }
        const scrollTop :number = window.scrollY;
        const threshold :number = toPx(this.options.threshold);
        let   state :state;
        if ((scrollTop + window.innerHeight) >= threshold) { // TODO <= as soon as threshold is at BOTTOM of window ... option!
            state = states.AFTER;
        }
        else {
            state = states.BEFORE;
        }
        if (state !== this.state) {
            animationFrames.push(() :void => {
                this.setState(state);
                this.options.onChange(this.state);
                window.dispatchEvent(new CustomEvent(state === states.AFTER ? 'belowThreshold' : 'aboveThreshold'));
            });
        }
        return animationFrames;
    };

    // ###############
    // Private methods
    // ###############

    private setState(state :state) :Threshold
    {
        this.state = state;
        return this;
    }

}

export default Threshold;